<template>
  <sp-button
    tag="a"
    :variant="variant"
    size="small"
    block
    :title="slot.visit_type_categories_description"
    :href="slot.booking_url"
  >
    <sp-icon v-if="visitTypeIcon" slot="prepend" :name="visitTypeIcon" size="small"></sp-icon>
    {{ formatStartTime(slot.start_time) }}
  </sp-button>
</template>

<script setup>
import moment from "moment";
import { computed } from "vue";

const props = defineProps({
  entry: {
    type: Object,
    required: true,
  },
  variant: {
    type: String,
    default: "outlined",
  },
});
const slot = computed(() => props.entry);

const visitTypeIcon = computed(() => {
  if (slot.value.visit_type_categories.includes("video")) {
    return "video-visit-filled";
  }

  return undefined;
});

function formatStartTime(startTime) {
  return moment.parseZone(startTime).format("h:mm A");
}
</script>

<style scoped lang="scss">
sp-button {
  --sp-comp-button-small-padding: 0;
  --sp-comp-button-font-weight: var(--sp-comp-slot-button-font-weight, var(--sp-sys-typescale-body-font-weight));
  --sp-comp-button-primary-bg-color: var(--sp-comp-slot-button-bg-color);
  --sp-comp-button-primary-hover-bg-color: var(--sp-comp-slot-button-hover-bg-color);
}
</style>
